import { gql } from '@apollo/client';

export const RESIDENT_DETAILS_QUERY = gql`
  query GetResidentDetails {
    resident {
      renewalUnitsTicker
      isAutoPayEnabled
      activeLease {
        #        rentLeaseId
        #        unitTicker
        isInEviction
        evictionStartDate
        nextRentPayment {
          id
          residentId
          amount
          status
          dateDue
          lateFee
        }
        unpaidRentPayment {
          id
          amount
          status
          dateDue
          lateFee
          paymentType
        }
      }
    }
  }
`;
